













import { Component, Vue, Prop } from 'vue-property-decorator'
import { mdiPoll } from '@mdi/js'
import { namespace } from 'nuxt-property-decorator'
import ComponentFormButtonIcon from '~/components/form/button-icon.vue'
import { ICompareItem } from '~/assets/interfaces/compare'
const compareStore = namespace('compare')
@Component({
  components: {
    ComponentFormButtonIcon,
  },
})
export default class ComponentAddToCompareIconButton extends Vue {
  @Prop({ type: [String, Number] }) private productId: string | number
  @compareStore.Action('toCompare') private toCompare!: (args: {
    id: number | string
  }) => Promise<void>

  @compareStore.State('items') private compareItems!: ICompareItem[]
  private mdiPoll = mdiPoll
  private isLoading: boolean = false
  private async addToCompare() {
    if (!this.isLoading) {
      this.isLoading = true
      await this.toCompare({ id: this.productId })
      this.isLoading = false
    }
  }

  private get inCompare(): boolean {
    return !!this.compareItems.find((item) => item.id === this.productId)
  }
}
